import { render, staticRenderFns } from "./drupal-list-string.vue?vue&type=template&id=01d940aa&scoped=true&"
import script from "./drupal-list-string.vue?vue&type=script&lang=js&"
export * from "./drupal-list-string.vue?vue&type=script&lang=js&"
import style0 from "./drupal-list-string.vue?vue&type=style&index=0&id=01d940aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../create-website/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d940aa",
  null
  
)

export default component.exports